export default __webpack_public_path__ + "static/media/gray-close.486ed9ff.svg";